export default __webpack_public_path__ + "b18cdf9e1f6b6bbea63129665262be35.svg";